var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#323232",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.012 24.622 2.156.33a3.084 3.084 0 0 1 2.61 3.273l-.159 2.176c-.046.633.3 1.23.871 1.506l1.594.768a1.55 1.55 0 0 0 1.722-.258l1.602-1.48a3.084 3.084 0 0 1 4.186 0l1.601 1.48a1.546 1.546 0 0 0 1.722.258l1.598-.77c.57-.274.914-.87.868-1.501l-.16-2.179a3.084 3.084 0 0 1 2.61-3.273l2.156-.33a1.548 1.548 0 0 0 1.275-1.185l.393-1.724a1.544 1.544 0 0 0-.634-1.62l-1.799-1.232a3.084 3.084 0 0 1-.93-4.08l1.086-1.89c.316-.551.264-1.24-.133-1.737l-1.102-1.382a1.548 1.548 0 0 0-1.663-.515l-2.085.638a3.086 3.086 0 0 1-3.774-1.816l-.798-2.024a1.548 1.548 0 0 0-1.443-.98l-1.767.005a1.548 1.548 0 0 0-1.438.987l-.779 2.001a3.083 3.083 0 0 1-3.78 1.828l-2.17-.666a1.548 1.548 0 0 0-1.669.518l-1.094 1.385a1.547 1.547 0 0 0-.122 1.742l1.111 1.895a3.085 3.085 0 0 1-.917 4.104L4.98 20.09a1.546 1.546 0 0 0-.634 1.62l.393 1.724c.14.622.646 1.092 1.273 1.187h0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.454 16.046a4.178 4.178 0 1 1-5.91 5.908 4.178 4.178 0 0 1 5.91-5.908"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 .5h37v37H0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting-icon.776bb2925e947e5746206fb87ebcace1.svg";
export { ForwardRef as ReactComponent };